<template>
  <div>
    <b-card>
      <!-- Header -->
      <div class="m-2">
        <h3>* Contratos</h3>
        <b-row>
          <b-col md="10">
            <v-select
              v-model="contractCode"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="nombre"
              :options="contractList"
              input-id="idcontrato"
            />
          </b-col>
          <b-col md="2">
            <b-button
              variant="primary"
              @click="searchStatusAccount"
            >
              <feather-icon icon="SearchIcon" />
              Consultar
            </b-button>
          </b-col>
        </b-row>
      </div>

      <!-- Tabla -->
      <div>
        <b-table
          id="my-table"
          ref="refUserListTable"
          striped
          hover
          class="position-relative"
          :items="items"
          responsive
          :fields="fields"
          :sort-by.sync="sortBy"
          show-empty
          :filter="searchQuery"
          empty-text="No existen registros para mostrar"
          :sort-desc.sync="isSortDirDesc"
          :busy="isBusy"
          head-variant="dark"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" />
              <strong>Cargando...</strong>
            </div>
          </template>

          <template #cell()="data">
            <span class="rowstyle">{{ data.value }}</span>
          </template>

          <template #cell(id)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(resumen)="data">
            <b-button
              variant="info"
              size="sm"
              @click="resumenContract(data.item.idcontrato)"
            >
              Resumen
            </b-button>
          </template>

          <template #cell(pagar)="data">
            <b-button
              :variant="`${
                data.item.saldo > 0 ? 'danger' : 'success'
              }`"
              block
            >
              {{
                data.item.saldo > 0
                  ? `Pagar: ${data.item.saldo}`
                  : `Cuenta al dia`
              }}
            </b-button>
          </template>

          <template #cell(debito)="data">
            <b-button
              v-b-modal.modal-debit
              variant="success"
              size="sm"
              @click="setContract(data.item)"
            >
              Débito
            </b-button>
          </template>

          <template #cell(check)="data">
            <input
              :id="data.index + 1"
              v-model="data.item.check"
              type="checkbox"
              class="custom-control-success"
              checked
            >
          </template>

          <template #cell(adjunto)="data">
            <div
              class="d-flex align-items-center justify-content-center"
            >
              <b-badge
                v-if="data.item.tiene_adjunto"
                variant="success"
                pill
                class="mr-2"
              >
                <feather-icon
                  icon="CheckIcon"
                  size="12"
                  class="mr-1"
                />
                Con Adjunto
              </b-badge>
              <b-button
                v-b-modal.modal-adjunto
                :variant="
                  data.item.tiene_adjunto ? 'success' : 'info'
                "
                size="sm"
                @click="setAdjuntoItem(data.item)"
              >
                <feather-icon
                  :icon="
                    data.item.tiene_adjunto
                      ? 'EditIcon'
                      : 'UploadIcon'
                  "
                  class="mr-1"
                />
                {{
                  data.item.tiene_adjunto
                    ? 'Ver/Editar'
                    : 'Subir adjunto'
                }}
              </b-button>
            </div>
          </template>

          <template v-slot:custom-foot>
            <tr>
              <td
                colspan="5"
                align="right"
                class="bg-light-danger text-white"
              >
                TOTAL:
              </td>
              <td
                class="bg-light-danger text-white"
                align="right"
              >
                {{ totalbalance }}
              </td>
              <td
                class="bg-light-danger text-white"
                align="right"
              >
                {{ totalpagar }}
              </td>
              <td class="bg-light-danger text-white" />
              <td class="bg-light-danger text-white" />
            </tr>
          </template>
        </b-table>
      </div>

      <!-- Total Seleccionado -->
      <b-card class="mt-3">
        <div class="d-flex align-items-center justify-content-end">
          <div class="d-flex align-items-center mr-3">
            <div class="total-icon mr-2">
              <feather-icon
                icon="DollarSignIcon"
                size="16"
                class="text-white"
              />
            </div>
            <div>
              <span
                class="text-dark"
                style="font-size: 1.2rem"
              >
                Total Seleccionado:
              </span>
              <span
                class="text-dark font-weight-bold ml-2"
                style="font-size: 1.4rem"
              >
                {{ formatMoneda(totalSelected) }}
              </span>
            </div>
          </div>
          <b-button
            hidden
            variant="primary"
            :disabled="totalSelected <= 0"
            class="btn-payment mr-2"
            @click="proceedToPayment"
          >
            <feather-icon
              icon="CreditCardIcon"
              class="mr-1"
            />
            Proceder al Pago
          </b-button>

          <b-button
            variant="success"
            :disabled="
              !contractCode ||
                !contractCode.idcontrato ||
                totalSelected <= 0
            "
            class="btn-payment"
            @click="proceedToSubscription"
          >
            <feather-icon
              icon="CheckIcon"
              class="mr-1"
            />
            Suscripción
          </b-button>

          <b-button
            variant="info"
            :disabled="totalSelected <= 0"
            class="btn-payment ml-2"
            @click="proceedToDataFastPayment"
          >
            <feather-icon
              icon="CreditCardIcon"
              class="mr-1"
            />
            Pagar con DataFast
          </b-button>
          <b-button
            hidden
            variant="warning"
            class="btn-payment ml-2"
            @click="testDataFastAPI"
          >
            <feather-icon
              icon="TestTubeIcon"
              class="mr-1"
            />
            Probar API DataFast
          </b-button>
          <b-button
            hidden
            variant="info"
            :disabled="!contractCode || !contractCode.idcontrato"
            class="btn-payment ml-2"
            @click="proceedToStatement"
          >
            <feather-icon
              icon="FileTextIcon"
              class="mr-1"
            />
            Estado de Cuenta
          </b-button>
        </div>
      </b-card>
    </b-card>

    <!-- Pago -->
    <b-modal
      id="modal-paypal"
      ref="modal-paypal"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      title="Pago"
    >
      <pay-pal :idcontrato="contract.idcontrato" />
    </b-modal>

    <!-- Pago Automático -->
    <b-modal
      id="modal-payment"
      ref="modal-payment"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      title="Pago Automático"
    >
      <payment :contract="contract" />
    </b-modal>

    <!-- Débito -->
    <b-modal
      id="modal-debit"
      ref="modal-debit"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      title="Autorización de Suscripción a Débito"
    >
      <debit :contract="contract" />
    </b-modal>

    <!-- DataFast Payment -->
    <b-modal
      id="modal-datafast"
      ref="modal-datafast"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      title="Pago con DataFast"
    >
      <data-fast-payment
        :contract="contract"
        :terms-url="datafastTermsUrl"
        :privacy-url="datafastPrivacyUrl"
        @payment-success="handleDataFastSuccess"
        @payment-declined="handleDataFastDeclined"
        @payment-error="handleDataFastError"
        @close-modal="closeDataFastModal"
      />
    </b-modal>

    <!-- DataFast Test -->
    <b-modal
      id="modal-datafast-test"
      ref="modal-datafast-test"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      title="Prueba API DataFast"
    >
      <data-fast-test />
    </b-modal>

    <!-- DataFast Subscription -->
    <b-modal
      id="modal-datafast-subscription"
      ref="modal-datafast-subscription"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="xl"
      title="Gestión de Suscripciones DataFast"
    >
      <data-fast-subscription
        :contract="contract"
        @subscription-created="handleSubscriptionCreated"
      />
    </b-modal>

    <!-- Estado de Cuenta -->
    <b-modal
      id="modal-statement"
      ref="modal-statement"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="xl"
      title="Estado de Cuenta"
    >
      <contract-account-status :data="contract" />
    </b-modal>

    <!-- Modal Subir Adjunto de Mensualidad -->
    <b-modal
      id="modal-adjunto"
      ref="modal-adjunto"
      content-class="shadow"
      centered
      ok-variant="primary"
      ok-title="Guardar"
      cancel-title="Cancelar"
      no-close-on-backdrop
      size="md"
      title="Subir Adjunto de Mensualidad"
      @ok="saveAdjunto"
      @hidden="resetAdjuntoForm"
    >
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Pago:"
              label-for="pago"
            >
              <b-form-input
                id="pago"
                :value="adjuntoForm.pago || 0"
                type="number"
                readonly
                class="text-danger font-weight-bold"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group
              label="Fecha:"
              label-for="fecha"
            >
              <flat-pickr
                id="fecha"
                v-model="adjuntoForm.fecha"
                class="form-control"
                type="date"
                placeholder="Seleccione la fecha"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group
              label="Banco Emisor:"
              label-for="banco-emisor"
            >
              <v-select
                v-model="adjuntoForm.bancoEmisor"
                :dir="
                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                "
                :options="bancosEmisor"
                label="text"
                :reduce="(val) => val.value"
                placeholder="Seleccione banco emisor"
                input-id="banco-emisor"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Banco Receptor:"
              label-for="banco-receptor"
            >
              <v-select
                v-model="adjuntoForm.bancoReceptor"
                :dir="
                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                "
                :options="bancos"
                label="text"
                :reduce="(val) => val.value"
                placeholder="Seleccione banco receptor"
                input-id="banco-receptor"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group
              label="Referencia:"
              label-for="referencia"
            >
              <b-form-input
                id="referencia"
                v-model="adjuntoForm.referencia"
                type="text"
                placeholder="Ingrese solo números"
                @input="onReferenciaInput"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group
              label="Adjunto:"
              label-for="adjunto"
            >
              <b-form-file
                id="adjunto"
                v-model="adjuntoForm.archivo"
                placeholder="Agregar archivos"
                browse-text="Browse"
                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              />
              <small
                v-if="adjuntoForm.archivo"
                class="form-text text-muted"
              >
                Archivo seleccionado:
                {{ adjuntoForm.archivo.name }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import DataFastPayment from '@/components/DataFastPayment.vue'
import DataFastSubscription from '@/components/DataFastSubscription.vue'
import DataFastTest from '@/components/DataFastTest.vue'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import {
    BBadge,
    BButton,
    BCard,
    BCol,
    BForm,
    BFormFile,
    BFormGroup,
    BFormInput,
    BMedia,
    BModal,
    BRow,
    BSpinner,
    BTable,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import ContractAccountStatus from '../contract/ContractAccountStatus.vue'
import Debit from './Debit.vue'
import PayPal from './PayPal.vue'
import Payment from './Payment.vue'
import useList from './useList'

export default {
    components: {
        BCard,
        BRow,
        BCol,
        BTable,
        BSpinner,
        BMedia,
        BBadge,
        BForm,
        BFormFile,
        BFormGroup,
        BFormInput,
        BButton,
        BModal,
        vSelect,
        flatPickr,
        StatisticCardHorizontal,
        DataFastPayment,
        DataFastTest,
        DataFastSubscription,
        PayPal,
        Payment,
        Debit,
        ContractAccountStatus,
    },
    setup() {
        const {
            perPage,
            currentPage,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,
        } = useList()

        return {
            perPage,
            currentPage,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,
        }
    },
    data() {
        return {
            isBusy: false,
            userData: JSON.parse(localStorage.getItem('userData')),
            fields: [
                { key: 'id', label: '#' },
                { key: 'codigo', label: 'Codigo' },
                { key: 'tiponom', label: 'Tipo' },
                { key: 'fecha', label: 'Fecha' },
                { key: 'detalle', label: 'Concepto' },
                {
                    key: 'saldo',
                    label: 'Balance',
                    class: 'text-right',
                },
                {
                    key: 'pagar',
                    label: 'Pagar',
                    class: 'text-center',
                },
                {
                    key: 'check',
                    label: 'Seleccionar',
                    class: 'text-center',
                },
                {
                    key: 'adjunto',
                    label: 'Adjunto',
                    class: 'text-center',
                },
            ],
            items: [],
            keyPayPal: null,
            contract: {},
            contractCode: null,
            contractList: [],
            datafastTermsUrl: process.env.VUE_APP_DATAFAST_TERMS_URL || '',
            datafastPrivacyUrl: process.env.VUE_APP_DATAFAST_PRIVACY_URL || '',
            totalbalance: 0,
            totalpagar: 0,
            totalSelected: 0,
            adjuntoItem: null,
            adjuntoForm: {
                pago: 0,
                fecha: null,
                bancoEmisor: null,
                bancoReceptor: null,
                referencia: '',
                archivo: null,
            },
            bancos: [],
            bancosEmisor: [],
        }
    },
    computed: {},
    watch: {
        items: {
            handler(newItems) {
                this.updateTotalSelected()
            },
            deep: true,
        },
    },
    created() {
        if (!this.ensureUserData()) return
        this.getContractList()
        this.getBancos()
        this.getBancosEmisor()
    },
    mounted() {
        // Verificar si hay resultado de pago DataFast pendiente de mostrar
        const datafastResult = sessionStorage.getItem('datafast_result')
        if (datafastResult) {
            try {
                const result = JSON.parse(datafastResult)
                sessionStorage.removeItem('datafast_result')

                this.$swal({
                    title: result.success ? 'Pago Exitoso' : 'Pago Rechazado',
                    text:
                        result.message ||
                        (result.success
                            ? 'Tu pago ha sido procesado correctamente'
                            : 'No se pudo procesar el pago'),
                    icon: result.success ? 'success' : 'error',
                    customClass: {
                        confirmButton: result.success
                            ? 'btn btn-success'
                            : 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })

                // Recargar datos si el pago fue exitoso
                if (result.success) {
                    this.getContractList()
                    if (this.contractCode?.idcontrato) {
                        this.searchStatusAccount()
                    }
                }
            } catch (e) {}
        }

        // Verificar si hay tokenización pendiente de DataFast
        const urlParams = new URLSearchParams(window.location.search)
        const resourcePath = urlParams.get('resourcePath')
        const tokenizationData = sessionStorage.getItem('datafast_tokenization')

        if ((resourcePath || urlParams.get('id')) && tokenizationData) {
            this.$nextTick(() => {
                this.$bvModal.show('modal-datafast-subscription')
            })
        }
    },
    methods: {
        search() {
            if (!this.ensureUserData()) return
            this.isBusy = true
            this.$http
                .get('/usuario-contrato', {
                    params: {
                        idusuario: this.userData.id,
                        estado: 'A',
                    },
                })
                .then((response) => {
                    this.isBusy = false
                    this.items = response.data.data
                })
                .catch((error) => {
                    this.isBusy = false
                    this.$swal({
                        title: 'Error',
                        text: error.response.data.error,
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        },

        resumenContract(idcontrato) {
            this.$router.push({
                name: 'contract-id',
                params: { id: idcontrato },
            })
        },

        setContract(item) {
            this.contract = item
        },

        getContractList() {
            if (!this.ensureUserData()) return
            this.isBusy = true
            this.$http
                .get('/user-contract-code', {
                    params: {
                        idusuario: this.userData.id,
                        estado: 'A',
                    },
                })
                .then((response) => {
                    this.isBusy = false
                    this.contractList = response.data.data
                })
                .catch((error) => {
                    this.isBusy = false
                    const errorMessage =
                        error.response?.data?.error ||
                        error.response?.data?.message ||
                        error.message ||
                        'No se pudo conectar con el servidor'

                    this.$swal({
                        title: 'Error al Cargar Contratos',
                        text: errorMessage,
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        },

        searchStatusAccount() {
            if (!this.contractCode || !this.contractCode.idcontrato) {
                this.$swal({
                    title: 'Advertencia',
                    text: 'Debe seleccionar un Contrato',
                    icon: 'warning',
                    customClass: {
                        confirmButton: 'btn btn-warning',
                    },
                })
                return
            }

            this.isBusy = true
            this.$http
                .get('/statement-contract', {
                    params: {
                        idcontrato: this.contractCode.idcontrato,
                    },
                })
                .then((response) => {
                    this.isBusy = false
                    this.items = response.data.data
                    this.totalbalance = this.roundNumber(
                        this.items.reduce(
                            (sum, item) => sum + parseFloat(item.saldo || 0),
                            0
                        ),
                        2
                    )
                    this.totalpagar = this.roundNumber(
                        this.items.reduce(
                            (sum, item) => sum + parseFloat(item.saldo || 0),
                            0
                        ),
                        2
                    )
                })
                .catch((error) => {
                    this.isBusy = false

                    const errDetails = error.response?.data?.errors
                        ? error.response.data.errors
                        : error.response?.data?.message || 'Error desconocido'

                    this.$swal({
                        title: 'Advertencia',
                        text: JSON.stringify(errDetails),
                        icon: 'warning',
                        customClass: {
                            confirmButton: 'btn btn-warning',
                        },
                        buttonsStyling: false,
                    })
                })
        },

        formatMoneda(value) {
            const val = (value / 1).toFixed(2).replace(',', '.')

            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },

        roundNumber(value, precision) {
            if (Number.isInteger(precision)) {
                // eslint-disable-next-line no-restricted-properties
                const shift = Math.pow(10, precision)

                return Math.round(value * shift + 0.00000000000001) / shift
            }

            return Math.round(value)
        },

        ensureUserData() {
            if (this.userData?.id) return true
            this.userData = JSON.parse(localStorage.getItem('userData'))
            if (this.userData?.id) return true

            this.$swal({
                title: 'Sesión no disponible',
                text: 'Por favor inicia sesión nuevamente.',
                icon: 'warning',
                customClass: {
                    confirmButton: 'btn btn-warning',
                },
                buttonsStyling: false,
            })
            return false
        },

        updateTotalSelected() {
            this.totalSelected = this.items.reduce((sum, item) => {
                return item.check ? sum + parseFloat(item.saldo || 0) : sum
            }, 0)
        },

        proceedToPayment() {
            if (this.totalSelected <= 0) return

            // Ordenar items por fecha (de más antigua a más reciente)
            const itemsOrdenados = [...this.items].sort(
                (a, b) => new Date(a.fecha) - new Date(b.fecha)
            )

            // Verificar si la selección comienza desde la fecha más antigua
            let primeraFechaSeleccionada = false
            let hayError = false

            itemsOrdenados.forEach((item) => {
                if (item.check && !primeraFechaSeleccionada) {
                    // Si es el primer item seleccionado, verificar que sea el más antiguo
                    const indiceActual = itemsOrdenados.indexOf(item)
                    const itemsAntes = itemsOrdenados.slice(0, indiceActual)
                    if (itemsAntes.length > 0) {
                        hayError = true
                    }
                    primeraFechaSeleccionada = true
                } else if (item.check && primeraFechaSeleccionada) {
                    // Verificar que no haya items no seleccionados antes
                    const indiceActual = itemsOrdenados.indexOf(item)
                    const itemsAntes = itemsOrdenados.slice(0, indiceActual)
                    if (itemsAntes.some((itemAntes) => !itemAntes.check)) {
                        hayError = true
                    }
                }
            })

            if (hayError) {
                this.$swal({
                    title: 'Advertencia',
                    text: 'Debe comenzar la Selección desde la Fecha más Antigua y no puede Saltar Fechas',
                    icon: 'warning',
                    customClass: {
                        confirmButton: 'btn btn-warning',
                    },
                    buttonsStyling: false,
                })
                return
            }

            const selectedItems = this.items.filter((item) => item.check)
            this.contract = {
                ...this.contract,
                selectedItems,
                totalSelected: this.totalSelected,
            }

            this.$bvModal.show('modal-payment')
        },

        proceedToSubscription() {
            if (!this.contractCode || !this.contractCode.idcontrato) {
                this.$swal({
                    title: 'Advertencia',
                    text: 'Debe seleccionar un Contrato',
                    icon: 'warning',
                    customClass: { confirmButton: 'btn btn-warning' },
                    buttonsStyling: false,
                })
                return
            }

            if (this.totalSelected <= 0) {
                this.$swal({
                    title: 'No hay valor a pagar',
                    text: 'Para suscribir una tarjeta debes seleccionar al menos una factura con saldo pendiente. Datafast requiere un cobro real para tokenizar la tarjeta (guía v3.3).',
                    icon: 'warning',
                    customClass: { confirmButton: 'btn btn-warning' },
                    buttonsStyling: false,
                })
                return
            }

            this.contract = {
                ...this.contractCode,
                selectedItems: this.items.filter((i) => i.check),
                totalSelected: this.totalSelected,
            }

            this.$bvModal.show('modal-datafast-subscription')
        },

        proceedToStatement() {
            if (!this.contractCode || !this.contractCode.idcontrato) {
                this.$swal({
                    title: 'Advertencia',
                    text: 'Debe seleccionar un Contrato',
                    icon: 'warning',
                    customClass: {
                        confirmButton: 'btn btn-warning',
                    },
                    buttonsStyling: false,
                })
                return
            }

            this.contract = this.contractCode

            this.$bvModal.show('modal-statement')
        },

        handleDataFastSuccess(result) {
            // NO cerrar el modal inmediatamente, dejar que el componente muestre el resultado
            // El modal se puede cerrar manualmente después de ver el mensaje

            // Opcional: Cerrar después de un delay para que vean el mensaje
            setTimeout(() => {
                this.$bvModal.hide('modal-datafast')

                // Recargar datos del contrato primero
                this.getContractList()

                // Mostrar mensaje de éxito adicional
                this.$swal({
                    title: '¡Pago Exitoso!',
                    text:
                        result.message ||
                        'Tu pago ha sido procesado correctamente',
                    icon: 'success',
                    customClass: {
                        confirmButton: 'btn btn-success',
                    },
                    buttonsStyling: false,
                })

                // Ya estamos en /home, no es necesario redirigir
            }, 2000) // Esperar 2 segundos para que vean el resultado en el componente
        },

        handleDataFastDeclined(result) {
            setTimeout(() => {
                this.$bvModal.hide('modal-datafast')

                // Mostrar mensaje informativo
                this.$swal({
                    title: 'Pago Rechazado',
                    text:
                        result.message ||
                        'Tu pago fue rechazado. Por favor, verifica los datos de tu tarjeta e intenta nuevamente.',
                    icon: 'warning',
                    customClass: {
                        confirmButton: 'btn btn-warning',
                    },
                    buttonsStyling: false,
                })
            }, 4000) // Esperar 4 segundos para que vean el mensaje del componente
        },

        handleDataFastError(errorData) {
            setTimeout(() => {
                this.$bvModal.hide('modal-datafast')

                // Mostrar mensaje de error al usuario
                this.$swal({
                    title: 'Error en el Pago',
                    text:
                        errorData.error ||
                        'Hubo un problema al procesar tu pago. Por favor, intenta nuevamente.',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })
            }, 3000) // Esperar 3 segundos para que vean el error del componente
        },

        closeDataFastModal() {
            this.$bvModal.hide('modal-datafast')
        },

        handleSubscriptionCreated(tokenData) {
            // Ocultar modal
            this.$bvModal.hide('modal-datafast-subscription')

            // Mostrar mensaje de éxito
            this.$swal({
                title: '¡Suscripción Creada!',
                text: 'Tu tarjeta ha sido registrada exitosamente para pagos recurrentes',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                buttonsStyling: false,
            })
        },

        testDataFastAPI() {
            this.$bvModal.show('modal-datafast-test')
        },

        proceedToDataFastPayment() {
            if (this.totalSelected <= 0) {
                this.$swal({
                    title: 'Advertencia',
                    text: 'Debe seleccionar al menos un item para pagar',
                    icon: 'warning',
                    customClass: {
                        confirmButton: 'btn btn-warning',
                    },
                    buttonsStyling: false,
                })
                return
            }

            // Ordenar items por fecha (de más antigua a más reciente)
            const itemsOrdenados = [...this.items].sort(
                (a, b) => new Date(a.fecha) - new Date(b.fecha)
            )

            let haySeleccion = false
            let yaHuboNoSeleccionadoDespuesDeSeleccion = false
            let hayError = false

            for (const item of itemsOrdenados) {
                if (item.check) {
                    haySeleccion = true
                    if (yaHuboNoSeleccionadoDespuesDeSeleccion) {
                        hayError = true
                        break
                    }
                } else if (haySeleccion) {
                    yaHuboNoSeleccionadoDespuesDeSeleccion = true
                }
            }

            if (hayError) {
                this.$swal({
                    title: 'Error en la selección',
                    text: 'Debe seleccionar los items desde la fecha más antigua',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })
                return
            }

            const selectedItems = this.items.filter((item) => item.check)

            this.contract = {
                ...this.contractCode,
                selectedItems,
                totalSelected: this.totalSelected,
            }

            this.$bvModal.show('modal-datafast')
        },

        setAdjuntoItem(item) {
            this.adjuntoItem = item
            this.adjuntoForm.pago = item.saldo || 0
        },

        resetAdjuntoForm() {
            this.adjuntoForm = {
                pago: 0,
                fecha: null,
                bancoEmisor: null,
                bancoReceptor: null,
                referencia: '',
                archivo: null,
            }
            this.adjuntoItem = null
        },

        saveAdjunto(bvModalEvent) {
            bvModalEvent.preventDefault()

            // Validar que el adjunto esté presente
            if (!this.adjuntoForm.archivo) {
                this.$swal({
                    title: 'Advertencia',
                    text: 'Debe seleccionar un archivo adjunto',
                    icon: 'warning',
                    customClass: {
                        confirmButton: 'btn btn-warning',
                    },
                    buttonsStyling: false,
                })
                return
            }

            // Validar que la referencia solo contenga números
            if (
                this.adjuntoForm.referencia &&
                /[^0-9]/.test(this.adjuntoForm.referencia)
            ) {
                this.$swal({
                    title: 'Error',
                    text: 'El campo Referencia solo puede contener números. No se permiten letras.',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })
                return
            }

            // Crear FormData para enviar el archivo
            const formData = new FormData()
            formData.append('archivo', this.adjuntoForm.archivo)
            formData.append(
                'idcontrato',
                this.adjuntoItem?.idcontrato || this.contractCode?.idcontrato
            )
            formData.append('idusuario', this.userData.id)
            // Agregar idempresa para buscar información de bancos si es necesario
            if (
                this.userData?.idempresa ||
                this.userData?.userData?.idempresa
            ) {
                formData.append(
                    'idempresa',
                    this.userData.idempresa || this.userData.userData.idempresa
                )
            }
            formData.append('pago', this.adjuntoForm.pago)
            formData.append('codigo', this.adjuntoItem?.codigo || '')
            formData.append('fecha', this.adjuntoItem?.fecha || '')
            formData.append('saldo', this.adjuntoItem?.saldo || 0)
            if (this.adjuntoForm.fecha) {
                formData.append('fecha_pago', this.adjuntoForm.fecha)
            }
            if (this.adjuntoForm.bancoEmisor) {
                formData.append('banco_emisor', this.adjuntoForm.bancoEmisor)
                // Buscar el banco emisor completo para obtener nombre y cuenta
                const bancoEmisorCompleto = this.bancosEmisor.find(
                    (b) => b.value === this.adjuntoForm.bancoEmisor
                )
                if (bancoEmisorCompleto && bancoEmisorCompleto.item) {
                    const banco = bancoEmisorCompleto.item
                    if (banco.name || banco.banco || banco.nombre) {
                        formData.append(
                            'banco_emisor_nombre',
                            banco.name || banco.banco || banco.nombre
                        )
                    }
                    if (
                        banco.account ||
                        banco.numerocuenta ||
                        banco.cuentabanco ||
                        banco.cuenta ||
                        banco.numero_cuenta
                    ) {
                        formData.append(
                            'banco_emisor_cuenta',
                            banco.account ||
                                banco.numerocuenta ||
                                banco.cuentabanco ||
                                banco.cuenta ||
                                banco.numero_cuenta
                        )
                    }
                }
            }
            if (this.adjuntoForm.bancoReceptor) {
                formData.append(
                    'banco_receptor',
                    this.adjuntoForm.bancoReceptor
                )
                // Buscar el banco receptor completo para obtener nombre y cuenta
                const bancoReceptorCompleto = this.bancos.find(
                    (b) => b.value === this.adjuntoForm.bancoReceptor
                )
                if (bancoReceptorCompleto && bancoReceptorCompleto.item) {
                    const banco = bancoReceptorCompleto.item
                    if (banco.banco || banco.nombre) {
                        formData.append(
                            'banco_receptor_nombre',
                            banco.banco || banco.nombre
                        )
                    }
                    if (
                        banco.numerocuenta ||
                        banco.cuentabanco ||
                        banco.cuenta ||
                        banco.numero_cuenta
                    ) {
                        formData.append(
                            'banco_receptor_cuenta',
                            banco.numerocuenta ||
                                banco.cuentabanco ||
                                banco.cuenta ||
                                banco.numero_cuenta
                        )
                    }
                }
            }
            if (this.adjuntoForm.referencia) {
                formData.append('referencia', this.adjuntoForm.referencia)
            }

            // Aquí puedes agregar la lógica para guardar el adjunto
            // Por ejemplo, hacer una petición HTTP al backend
            this.$http
                .post('/adjunto-mensualidad', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then((response) => {
                    // Marcar el item como con adjunto
                    if (this.adjuntoItem) {
                        this.adjuntoItem.tiene_adjunto = true
                    }

                    this.$bvModal.hide('modal-adjunto')
                    this.resetAdjuntoForm()
                    this.$swal({
                        title: 'Éxito',
                        text: 'Adjunto guardado correctamente',
                        icon: 'success',
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    }).then(() => {
                        window.location.reload()
                    })
                })
                .catch((error) => {
                    this.$swal({
                        title: 'Error',
                        text:
                            error.response?.data?.error ||
                            'Error al guardar el adjunto',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        },

        getBancos() {
            const idempresa =
                this.userData?.idempresa || this.userData?.userData?.idempresa

            if (!idempresa) {
                return
            }

            this.$http
                .get('/banco-lista', {
                    params: {
                        idempresa: idempresa,
                    },
                })
                .then((response) => {
                    // La respuesta tiene estructura: { data: { banco: [...] } }
                    let bancosArray = []

                    if (response.data && response.data.data) {
                        // Si viene dentro de data.banco
                        if (
                            response.data.data.banco &&
                            Array.isArray(response.data.data.banco)
                        ) {
                            bancosArray = response.data.data.banco
                        }
                        // Si data.data es directamente un array
                        else if (Array.isArray(response.data.data)) {
                            bancosArray = response.data.data
                        }
                    }
                    // Si response.data es directamente un array
                    else if (Array.isArray(response.data)) {
                        bancosArray = response.data
                    }

                    // Mapear los bancos al formato que espera el select
                    // Mostrar banco y cuenta juntos en el texto
                    this.bancos = bancosArray.map((item) => {
                        const bancoNombre =
                            item.banco ||
                            item.nombre ||
                            item.text ||
                            item.label ||
                            ''
                        // Buscar el campo de cuenta (puede ser numerocuenta, cuentabanco, cuenta, etc)
                        const cuentaNumero =
                            item.numerocuenta ||
                            item.cuentabanco ||
                            item.cuenta ||
                            item.numero_cuenta ||
                            ''

                        // Si hay número de cuenta, combinarlo con el banco
                        const textoCompleto = cuentaNumero
                            ? `${bancoNombre} - ${cuentaNumero}`
                            : bancoNombre

                        return {
                            value:
                                item.idbanco ||
                                item.idcuentabanco ||
                                item.value ||
                                item.id ||
                                item.codigo,
                            text: textoCompleto,
                            // Guardar también los datos completos por si se necesitan después
                            item: item,
                        }
                    })
                })
                .catch((error) => {})
        },

        getBancosEmisor() {
            this.$http
                .get('/bank')
                .then((response) => {
                    if (response.data && response.data.data) {
                        this.bancosEmisor = response.data.data
                            .filter((item) => item.is_status === true)
                            .map((item) => ({
                                value: item.id,
                                text: item.name,
                                // Guardar también los datos completos por si se necesitan después
                                item: item,
                            }))
                    }
                })
                .catch((error) => {})
        },

        onReferenciaInput(event) {
            // Solo permitir números
            const value = event.target.value.replace(/\D/g, '')
            this.adjuntoForm.referencia = value
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

// Main card styling
.card {
    border: none;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

// Section header
.m-2 h3 {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;

    &::before {
        content: '';
        width: 4px;
        height: 24px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 2px;
    }
}

// Table styling
.table {
    border-radius: 12px;
    overflow: hidden;

    thead {
        th {
            background: linear-gradient(
                135deg,
                #1e293b 0%,
                #334155 100%
            ) !important;
            color: #fff !important;
            font-weight: 600;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            padding: 14px 12px;
            border: none !important;
        }
    }

    tbody {
        tr {
            transition: all 0.2s ease;

            &:hover {
                background-color: #f8fafc !important;
                transform: scale(1.001);
            }

            td {
                padding: 12px;
                vertical-align: middle;
                border-color: #e2e8f0 !important;
            }
        }
    }
}

.rowstyle {
    font-size: 13px;
    color: #334155;
    font-weight: 500;
}

// Total row
.bg-light-danger {
    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%) !important;
    color: #991b1b !important;
    font-weight: 700 !important;
    font-size: 14px;
}

// Total selected card
.mt-3.card {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
}

.total-icon {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

// Buttons
.btn-payment {
    min-width: 160px;
    padding: 12px 20px;
    font-weight: 600;
    font-size: 14px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    border: none;

    &:hover:not(:disabled) {
        transform: translateY(-3px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    }

    &:active:not(:disabled) {
        transform: translateY(-1px);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }
}

.btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;

    &:hover {
        box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4) !important;
    }
}

.btn-success {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
    border: none !important;

    &:hover {
        box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4) !important;
    }
}

.btn-info {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
    border: none !important;

    &:hover {
        box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4) !important;
    }
}

.btn-danger {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    border: none !important;
}

// Vue Select styling
.vs__dropdown-toggle {
    border-radius: 10px;
    border: 2px solid #e2e8f0;
    padding: 8px 12px;
    transition: all 0.2s ease;

    &:hover {
        border-color: #667eea;
    }
}

.vs__dropdown-toggle:focus-within {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.vs__search {
    font-size: 14px;
}

.vs__selected {
    font-size: 14px;
    font-weight: 500;
    color: #1e293b;
}

// Checkbox styling
input[type='checkbox'] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #667eea;
}

// Modal improvements
.modal-content {
    border: none;
    border-radius: 16px;
    overflow: hidden;
}

.modal-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    border: none;
    padding: 20px 24px;
    position: relative;

    .modal-title {
        font-weight: 600;
    }

    .close {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        background: #ef4444 !important;
        color: #fff !important;
        opacity: 1 !important;
        text-shadow: none !important;
        font-size: 24px;
        font-weight: 400;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        margin: 0;
        line-height: 1;

        &:hover {
            background: #dc2626 !important;
        }
    }
}

.modal-body {
    padding: 24px;
}

// Responsive
@media (max-width: 768px) {
    .btn-payment {
        min-width: 100%;
        margin-bottom: 10px;
    }

    .d-flex.align-items-center.justify-content-end {
        flex-direction: column;
        align-items: stretch !important;
    }

    .mr-3,
    .ml-2 {
        margin: 0 0 10px 0 !important;
    }
}
</style>
